<table class="table table-striped">
	<thead>
		<tr class="text-center">
			<th scope="col">Bénéficiaire</th>
			<th scope="col" *ngFor="let day of dayOfWeekList">
				{{ day }} {{ getFormattedDate(day) | date : 'dd/MM' }}
			</th>
		</tr>
	</thead>
	<tbody>
		<tr>
			<td colspan="1"></td>
			<td *ngFor="let i of [].constructor(5)">
				<table class="table text-center table-borderless mb-0">
					<thead>
						<tr class="row">
							<th class="col-6" scope="col">Matin</th>
							<th class="col-6" scope="col">Après-midi</th>
						</tr>
					</thead>
				</table>
			</td>
		</tr>
		<tr
			*ngFor="
				let dataWeekView of dataWeekViewListing
					| filterListViewByIdentity : appliedFilter
			"
		>
			<td class="text-center h-100" colspan="1">
				<p class="m-0">{{ dataWeekView.identity.split(' ')[0] }}</p>
				<p class="m-0">{{ dataWeekView.identity.split(' ')[1] }}</p>
			</td>
			<td
				class="border-end"
				*ngFor="let missionListofList of dataWeekView.missions"
			>
				<!-- Création d'un tableau dans la colonne pour séparé les missions du matin et de l'après-midi -->
				<table class="table text-center mb-0 table-borderless">
					<thead class="text-start">
						<tr class="row text-center">
							<!-- Missions du matin et de l'après-midi séparé en 2 <th></th> -->
							<th
								class="col-sm-12 col-md-12 col-lg-6 d-flex justify-content-center"
								scope="col"
								*ngFor="let missionList of missionListofList"
							>
								<tbody class="m-0 p-1">
									<!-- Listing des missions de la demi-journée -->
									<tr
										*ngFor="let mission of missionList"
										class="badge m-1"
										[ngStyle]="{
											'background-color': getColorMission(mission)
										}"
										[title]="getTitleForMission(mission)"
									>
										<div role="button" (click)="openEventModal(mission.id)">
											<p class="m-0 mb-1">
												{{ mission.plannedStart | minutesToTime }}
												-
												{{ mission.plannedEnd | minutesToTime }}
											</p>
											<!-- AFFICHAGE DU NOM DU BENEFICIAIRE OU DU TYPE DE MISSION-->

											<p
												class="m-0"
												*ngIf="
													!isMissionReunion(mission) &&
													!isMissionInGroup(mission)
												"
											>
												<span *ngIf="!isViewByIntervenant">
													<ng-container
														*ngIf="
															isMissionAssigned(mission);
															else unassignedMission
														"
													>
														<span>
															{{
																mission.assignedEmployee?.lastName | titlecase
															}}
															{{
																mission.assignedEmployee?.firstName.substring(
																	0,
																	1
																) | uppercase
															}}.
														</span>
													</ng-container>
													<ng-template #unassignedMission>
														<span>Non assignée</span>
													</ng-template>
												</span>
												<span *ngIf="isViewByIntervenant">
													{{
														mission.missionRequest.beneficiaire.lastName
															| titlecase
													}}
													{{
														mission.missionRequest.beneficiaire.firstName.substring(
															0,
															1
														) | uppercase
													}}.
												</span>
											</p>
											<p class="m-0" *ngIf="isMissionInGroup(mission)">
												En groupe
											</p>
											<p class="m-0" *ngIf="isMissionReunion(mission)">
												Réunion
											</p>
										</div>
									</tr>
								</tbody>
							</th>
						</tr>
					</thead>
				</table>
			</td>
		</tr>
	</tbody>
</table>
